import { useContext, useEffect, useState } from "react";
import { } from 'react-router-dom';

import MyContext from "../context/context";

// MUI
import { AccountBalance, CalendarMonth, CurrencyRupee, Discount, Info, Receipt, TrendingUp } from '@mui/icons-material';
import { Alert, Box, Card, CardContent, Container, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import axios from "axios";

export default function PaymentStudent() {
    const api = useContext(MyContext)
    useEffect(() => {
        window.scroll(0, 0)
        Payment()
    }, [])

    const [pay, setPay] = useState([])
    const Payment = () => {
        axios.get(`${api.api.student}?my-dashboard`)
            .then(function (res) {
                if (res.data.status !== false) {
                    if (res.data.pay.status === true) {
                        setPay(res.data.pay.data)
                    }
                }
            })
    }

    const [payhis, setPayhis] = useState([])

    useEffect(() => {
        axios.get(`${api.api.student}?payment-history`)
            .then(function (res) {
                if (res.data.status === false) {
                    setPayhis(res.data)
                } else {
                    setPayhis(res.data.data)
                }
            })
    }, [])

    const totalPayable = parseInt(pay.fees || 0) - parseInt(pay.discount || 0);
    const paymentProgress = totalPayable > 0 ? (parseInt(pay.payed || 0) / totalPayable) * 100 : 0;
    const totalTransactions = Array.isArray(payhis) ? payhis.length : 0;

    return (
        <Box>
            <Container maxWidth="lg">
                <Box sx={{ py: 2 }}>
                    {/* Page Header */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" fontWeight={700} mb={1} className="orbitron">
                            Payment Overview
                        </Typography>
                        <Typography variant="body2" color="text.secondary" fontSize={13}>
                            Track your fee payments, view transaction history, and monitor your payment progress. All amounts are in Indian Rupees (₹).
                        </Typography>
                    </Box>

                    {/* Compact Stats Grid */}
                    <Grid container spacing={2} mb={2}>
                        {/* Total Fees */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#DBEAFE',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <AccountBalance sx={{ color: '#2563EB', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Total Fees
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="text.primary">
                                        ₹{parseInt(pay.fees || 0).toLocaleString('en-in')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Payable */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#FEE2E2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <CurrencyRupee sx={{ color: '#DC2626', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Payable
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#DC2626">
                                        ₹{totalPayable.toLocaleString('en-in')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Paid */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#D1FAE5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <TrendingUp sx={{ color: '#059669', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Paid
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#059669">
                                        ₹{parseInt(pay.payed || 0).toLocaleString('en-in')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Balance */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#FEF3C7',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <CurrencyRupee sx={{ color: '#D97706', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Balance
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#D97706">
                                        ₹{(totalPayable - parseInt(pay.payed || 0)).toLocaleString('en-in')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mb={2}>
                        {/* Progress Card */}
                        <Grid item xs={12} md={8}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Typography variant="caption" color="text.secondary" fontSize={11} mb={1.5} display="block">
                                        Track how much of your total payable amount has been cleared
                                    </Typography>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                                        <Typography variant="body2" fontWeight={600} color="text.secondary">
                                            Payment Progress
                                        </Typography>
                                        <Typography variant="h6" fontWeight={700} color="#059669">
                                            {Math.round(paymentProgress)}%
                                        </Typography>
                                    </Stack>
                                    <LinearProgress
                                        variant="determinate"
                                        value={paymentProgress}
                                        sx={{
                                            height: 6,
                                            borderRadius: 3,
                                            backgroundColor: 'rgba(0,0,0,0.06)'
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Additional Info Cards */}
                        {parseInt(pay.discount || 0) > 0 && (
                            <Grid item xs={6} md={2}>
                                <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                    <CardContent sx={{ p: 2 }}>
                                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                            <Box sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: 1.5,
                                                backgroundColor: '#D1FAE5',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Discount sx={{ color: '#059669', fontSize: 16 }} />
                                            </Box>
                                            <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={10}>
                                                Discount
                                            </Typography>
                                        </Stack>
                                        <Typography variant="body1" fontWeight={700} color="#059669" fontSize={16}>
                                            ₹{parseInt(pay.discount).toLocaleString('en-in')}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}

                        <Grid item xs={6} md={parseInt(pay.discount || 0) > 0 ? 2 : 4}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 28,
                                            height: 28,
                                            borderRadius: 1.5,
                                            backgroundColor: '#DBEAFE',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <CalendarMonth sx={{ color: '#2563EB', fontSize: 16 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={10}>
                                            Transactions
                                        </Typography>
                                    </Stack>
                                    <Typography variant="body1" fontWeight={700} color="#2563EB" fontSize={16}>
                                        {totalTransactions}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    {/* Info Alert */}
                    {(totalPayable - parseInt(pay.payed || 0)) > 0 && (
                        <Alert
                            severity="info"
                            icon={<Info fontSize="small" />}
                            sx={{
                                mb: 2,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'rgba(0, 0, 0, 0.07)',
                                fontSize: 12,
                                py: 0.5
                            }}
                        >
                            You have a pending balance of ₹{(totalPayable - parseInt(pay.payed || 0)).toLocaleString('en-in')}. Please clear your dues at the earliest.
                        </Alert>
                    )}

                    {/* Payment History */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body1" fontWeight={700} mb={0.5}>
                            Payment History ({totalTransactions})
                        </Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={11}>
                            Complete record of all your fee payments with transaction details
                        </Typography>
                    </Box>

                    {payhis.status === false ?
                        <Alert
                            severity="warning"
                            sx={{
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'rgba(0, 0, 0, 0.07)',
                                fontSize: 14
                            }}
                        >
                            {payhis.msg}
                        </Alert>
                        :
                        <Stack spacing={1.5}>
                            {payhis.map((row, i) => (
                                <Card
                                    key={i}
                                    sx={{
                                        borderRadius: 2,
                                        backgroundColor: 'white',
                                        boxShadow: 'none',
                                        border: '1px solid',
                                        borderColor: 'rgba(0, 0, 0, 0.07)'
                                    }}
                                >
                                    <CardContent sx={{ p: 2 }}>
                                        <Stack direction="row" alignItems="center" spacing={1.5} mb={1.5}>
                                            <Box sx={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: 1.5,
                                                backgroundColor: '#DBEAFE',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Receipt sx={{ color: '#2563EB', fontSize: 18 }} />
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Typography variant="body2" fontWeight={700}>
                                                    ₹{parseInt(row.amount).toLocaleString('en-in')}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" fontSize={11}>
                                                    {new Date(row.p_date).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })}
                                                </Typography>
                                            </Box>
                                            <Typography variant="caption" color="#D97706" fontWeight={600} fontSize={11}>
                                                #{row.paymentid}
                                            </Typography>
                                        </Stack>

                                        {row.description && (
                                            <Typography variant="caption" color="text.secondary" fontSize={11}>
                                                {row.description}
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    }
                </Box>
            </Container>
        </Box>
    );
}